module.exports = __webpack_public_path__ + "static/img/04913872.ca328a64.png";